<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-9">
        <div class="container-fluid">
          <div class="row">
            <div class="d-flex m-auto mt-3">
              <button
                type="button"
                class="w-10"
                style="
                  border: 2px #1481da solid;
                  color: #1481da;
                  height: 40px;
                  background: none;
                  border-radius: 15px;
                "
                @click="getProduct()"
              >
                Tất cả
              </button>
              <button
                type="button"
                class="w-10"
                v-for="itemCate in listCate"
                :key="itemCate"
                style="
                  border: 2px #1481da solid;
                  color: #1481da;
                  height: 40px;
                  background: none;
                  border-radius: 15px;
                  margin-left: 10px;
                "
                @click="getProduct(itemCate.id)"
              >
                {{ itemCate.catName }}
              </button>
            </div>

            <div
              class="card mt-3"
              style="width: 18rem"
              v-for="itemProduct in listProduct"
              :key="itemProduct"
              @click="detailProduct(itemProduct)"
            >
              <img
                :src="imageUrls.urlAnh2 + itemProduct.image"
                style="   width: 200px;
                        height: 200px;
                        background-size: cover;
                        background-repeat: no-repeat;"
                class="card-img-top"
                alt=""
              />
              <div class="card-body">
                <h5 class="card-title">{{ itemProduct.productName }}</h5>
                <p class="card-text">
                  {{ itemProduct.description }}
                </p>
                <span style="color: red; font-size: 18px; font-weight: 600">
                  {{ itemProduct.gia }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3">
        <div class="modal-body">
          <div class="container-fluid p-0">
            <div class="row">
              <div class="d-flex flex-column align-items-center">
                <span style="text-align: start; color: #cbcbcb"> Chọn ảnh</span>
                <div class="drop-zone m-2">
                  <label
                    for="fileInput"
                    class="drop-zone__prompt d-flex"
                    style="cursor: pointer"
                    :style="{ backgroundImage: 'url(' + selectedImage + ')' }"
                  >
                    <span
                      class="m-auto"
                      v-if="!selectedImage"
                      style="color: #1481da; cursor: pointer"
                      >+</span
                    >
                  </label>
                  <input
                    id="fileInput"
                    type="file"
                    class="drop-zone__input"
                    ref="fileInput"
                    style="display: none"
                    accept="image/*"
                    @change="handleFileSelected"
                    single
                  />
                </div>
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb">
                  Tên sản phẩm</label
                >
                <input
                  style="height: 40px; border-bottom: 1px #cbcbcb solid"
                  v-model="nameProduct"
                />
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb"> Mô tả</label>
                <textarea
                  style="height: 70px; border-bottom: 1px #cbcbcb solid"
                  v-model="moTaProduct"
                ></textarea>
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb">
                  Giá (VND)</label
                >
                <input
                  style="height: 40px; border-bottom: 1px #cbcbcb solid"
                  v-model="giaProduct"
                />
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb">
                  Danh mục</label
                >
                <select
                  v-model="selectedCategoryId"
                  style="height: 40px; border-bottom: 1px #cbcbcb solid"
                >
                  <option disabled>Chọn danh mục</option>
                  <option
                    v-for="itemCate in listCate"
                    :key="itemCate.idCate"
                    :value="itemCate.idCate"
                  >
                    {{ itemCate.catName }}
                  </option>
                </select>
                <!-- <input
                  style="height: 40px; border-bottom: 1px #cbcbcb solid"
                  v-model="danhMucProduct"
                /> -->
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between w-100 mt-5">
            <input
              class="w50"
              maxlength="6"
              style="height: 40px; border: 1px #cbcbcb solid"
              placeholder="Nhập 6 số token"
              v-model="token"
            />
            <button
              v-if="createProduct"
              class="w-50"
              type="button"
              style="
                border: 2px #1481da solid;
                color: white;
                height: 40px;
                background: #1481da;
                border-radius: 10px;
              "
              @click="postCreateProduct"
            >
              Thêm sản phẩm
            </button>
            <button
              v-if="updateProduct"
              class="w-50"
              type="button"
              style="
                border: 2px #1481da solid;
                color: white;
                height: 40px;
                background: #1481da;
                border-radius: 10px;
              "
              @click="postCreateProduct"
            >
              Sửa sản phẩm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  convertToBase64,
  getMD5,
  KEY_ID_STORE,
  KEY_PHONE_ID,
  KEY_SESSION_ID,
  postImage,
  postProduct,
} from "@/components/js/VposService";
import { imageUrls } from "@/components/js/urlImg";
import { postLayCategory, postLayItem } from "@/components/js/VposServiceDanh";
export default {
  data() {
    return {
      imageUrls: imageUrls,
      selectedImage: null,
      concatenatedURLs: "",
      nameProduct: "",
      moTaProduct: "",
      giaProduct: "",
      danhMucProduct: "",
      token: "",
      idCate: "",
      listCate: [],
      listProduct: [],
      createProduct: true,
      updateProduct: false,
      selectedCategoryId: null,
    };
  },
  watch: {
    selectedCategoryId(newValue) {
      const selectedCate = this.listCate.find(
        (cate) => cate.idCate === newValue
      );
      if (selectedCate) {
        // Lấy giá trị itemCate.idCate tương ứng với selectedCategoryId
        this.idCate = selectedCate.id;
        console.log("idCate của danh mục được chọn là:", this.idCate);
      }
    },
  },
  mounted() {
    this.getCategory();
    this.getProduct("");
  },
  methods: {
    detailProduct(itemProduct) {
      console.log(itemProduct);
      this.nameProduct = itemProduct.productName;
      this.moTaProduct = itemProduct.description;
      this.giaProduct = itemProduct.gia;
      this.selectedImage = imageUrls.urlAnh2 + itemProduct.image;
      this.updateProduct = true;
      this.createProduct = false;
      this.idCate = itemProduct.idCate;
      this.selectedCategoryId = itemProduct.idCate;
    },

    openFilePicker() {
      this.$refs.fileInput.click();
    },
    handleFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.selectedImage = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    chooseStore(item) {
      this.idCate = item.idStore;
      console.log(item);
    },
    async postAnh() {
      try {
        const imgURLs = [];
        const value = await convertToBase64(this.selectedImage);
        const idCheck = await getMD5(convertToBase64(this.selectedImage));
        const res = await postImage(value, idCheck);
        imgURLs.push(res.result);
        this.concatenatedURLs = imgURLs.join(";");
      } catch (e) {
        console.log(e);
        alert("Lỗi đẩy ảnh");
      }
    },
    async getCategory() {
      try {
        var sessionLogin = KEY_SESSION_ID;
        var idLogin = KEY_PHONE_ID;
        var idStore = KEY_ID_STORE;
        const res = await postLayCategory(sessionLogin, idLogin, idStore);
        this.listCate = res.result.docs;
      } catch (e) {
        console.log(e);
      }
    },

    async getProduct(category) {
      var dataItem;
      var idStore = KEY_ID_STORE;
      var sessionLogin = KEY_SESSION_ID;
      var idLogin = KEY_PHONE_ID;
      try {
        if (category) {
          dataItem = await postLayItem(
            sessionLogin,
            idLogin,
            idStore,
            category
          );
        } else {
          dataItem = await postLayItem(sessionLogin, idLogin, idStore, "");
        }
        this.listProduct = dataItem.result.docs;
      } catch (error) {
        console.log("selectCategory catch " + error);
      }
    },
    async postCreateProduct() {
      try {
        const imgURLs = [];
        const value = await convertToBase64(this.selectedImage);
        const idCheck = await getMD5(convertToBase64(this.selectedImage));
        const res = await postImage(value, idCheck);
        imgURLs.push(res.result);
        this.concatenatedURLs = imgURLs.join(";");
        try {
          var sessionLogin = KEY_SESSION_ID;
          var idLogin = KEY_PHONE_ID;
          var idStore = KEY_ID_STORE;
          var giaGiam = 0;
          var thumbnail = "";

          const res = await postProduct(
            sessionLogin,
            idLogin,
            this.token,
            this.giaProduct,
            giaGiam,
            idStore,
            this.idCate,
            this.nameProduct,
            this.concatenatedURLs,
            thumbnail,
            this.moTaProduct
          );
          if (res.msgCode == 1 && res) {
            alert("Thêm sản phẩm " +this.nameProduct + " thành công !")
            this.getProduct("");
                    }
          console.log(res);
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
        alert("Lỗi đẩy ảnh");
      }
    },
  },
};
</script>
<style>
.drop-zone__prompt {
  display: block;
  width: 98px;
  height: 98px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: auto;
  border-radius: 10px;
}
</style>